"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** DO NOT FORGOT 'npm run generate' after changing something here. */
var values = {
    name: 'DEFAULT',
    /** Colors */
    primary: '#FFC000',
    secondary: '#9f9F9f',
    /** Background */
    bgDark: '#000000',
    bgLight: '#FFF',
    /** Fonts */
    fontColor: '#333',
    fontColorTitle: '#000',
    fontColorOnLight: '#000',
    fontColorOnDark: '#fff',
    /** Breakpoints */
    breakpointMobile: '767px',
    breakpointTablet: '991px',
    breakpointDesktop: '1024px',
    breakpointWidescreen: '1216px',
    breakpointFullHd: '1408px',
    /** MaxWidth-Breakpoints */
    maxBreakpointMobile: '766px',
    /** MaxWidth */
    tablet: '768px',
    maxWidthContainer: '1170px',
    fonts: [
        {
            types: ['HEADLINE', 'DEFAULT'],
            fontFamily: 'Montserrat',
            fontWeight: 'wght@400;700;800'
        }
    ]
};
exports.default = values;
//# sourceMappingURL=defaultTheme.js.map